"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapV5DeviceToV3Device = exports.mapV3DeviceToV5Device = exports.mapV5DeviceResponse = exports.mapV5DevicePlaylistResponse = exports.mapDeviceChargeResponse = exports.mapBatchDeviceStatusResponse = exports.mapBatchActionStatusResponse = exports.mapDeviceV2PerchSettingsReponse = exports.mapDevicePerchSettingsReponse = exports.mapDeviceRegionResponse = exports.mapRecentErrors = exports.mapDeviceContent = exports.mapDeviceResponse = exports.mapDevicePlaylistResponse = void 0;
const ResourceClient_1 = require("./ResourceClient");
const urls_1 = __importDefault(require("./urls"));
const PlaylistClient_1 = require("./PlaylistClient");
const PresentationClient_1 = require("./PresentationClient");
const ApplicationClient_1 = require("./ApplicationClient");
const ThemeClient_1 = require("./ThemeClient");
const mapObjectValues_1 = __importDefault(require("./mapObjectValues"));
const LocationClient_1 = require("./LocationClient");
const ConnectionClient_1 = require("./ConnectionClient");
const mapMetricsResponse = (d) => ({
    wifi: d.wifi
        ? {
            rssi: d.wifi.rssi,
            ssid: d.wifi.ssid,
            lastMetricTime: d.wifi.last_metric_time,
        }
        : null,
    lte: d.lte
        ? {
            rssi: d.lte.rssi,
            lastMetricTime: d.lte.last_metric_time,
        }
        : null,
    system: d.system
        ? {
            cpuUsedPercent: d.system.cpu_used_percent,
            memUsedPercent: d.system.mem_used_percent,
            diskUsedPercent: d.system.disk_used_percent,
            lastMetricTime: d.system.last_metric_time,
        }
        : null,
    lastMetricTime: d.last_metric_time,
    connectionType: d.connection_type,
    activeMonitors: d.active_monitors,
    aiCameraStatus: d.ai_camera_status,
    rxCameraStatus: d.rx_camera_status,
    rxIrFrameStatus: d.rx_ir_frame_status,
});
const mapDevicePlaylistResponse = (dp) => ({
    id: dp.id,
    name: dp.name,
    resource: (0, ResourceClient_1.mapResourceResponse)(dp.resource),
});
exports.mapDevicePlaylistResponse = mapDevicePlaylistResponse;
const mapDeviceResponse = (d) => {
    var _a, _b, _c;
    return ({
        id: d.id,
        name: d.name,
        description: d.description,
        model: d.model,
        features: d.device_features,
        metrics: d.metrics ? mapMetricsResponse(d.metrics) : null,
        screenDimensions: d.screen_dimensions,
        screenOrientation: d.screen_orientation,
        publishedAt: d.published_at,
        registeredAt: d.registered_at,
        resinUuid: d.resin_uuid,
        playlistId: d.playlist_id,
        playlist: d.playlist ? (0, exports.mapDevicePlaylistResponse)(d.playlist) : null,
        isAudioOnly: d.is_audio_only,
        resource: (0, ResourceClient_1.mapResourceResponse)(d.resource),
        lastHeartbeatAt: d.last_heartbeat_at,
        lastOnlineAt: d.last_online_at,
        isLite: d.is_lite,
        isUhd: d.is_uhd,
        publishAck: (_a = d.publish_ack) !== null && _a !== void 0 ? _a : false,
        publishPlaybackSuccess: (_b = d.publish_playback_success) !== null && _b !== void 0 ? _b : false,
        publishPlaybackError: (_c = d.publish_playback_error) !== null && _c !== void 0 ? _c : false,
        timezone: d.timezone,
        activeHoursStart: d.active_hours_start,
        activeHoursEnd: d.active_hours_end,
        dailyRebootTime: d.daily_reboot_time,
        dailyRestartTime: d.daily_restart_time,
        toastRestaurantGuid: d.toast_restaurant_guid,
        services: d.services,
        deviceType: d.device_type,
        screenManufacturer: d.screen_manufacturer,
        screenModel: d.screen_model,
        screenOsVersion: d.screen_os_version,
        screenSerialNumber: d.screen_serial_number,
        location: d.location ? (0, LocationClient_1.mapLocationResponse)(d.location) : null,
        terminal: d.terminal
            ? {
                id: d.terminal.id,
                externalId: d.terminal.external_id,
                createdAt: d.terminal.created_at,
                updatedAt: d.terminal.updated_at,
                connection: null,
            }
            : null,
        activeMonitors: d.active_monitors,
        aiCameraStatus: d.ai_camera_status,
        rxCameraStatus: d.rx_camera_status,
        rxIrFrameStatus: d.rx_ir_frame_status,
    });
};
exports.mapDeviceResponse = mapDeviceResponse;
const mapDeviceContent = (d) => ({
    playlistId: d.playlist_id,
    playlists: d.playlists && (0, mapObjectValues_1.default)(d.playlists, PlaylistClient_1.mapPlaylistV2Response),
    presentations: d.presentations &&
        (0, mapObjectValues_1.default)(d.presentations, PresentationClient_1.mapPresentationV2Response),
    applicationVersions: d.application_versions &&
        (0, mapObjectValues_1.default)(d.application_versions, ApplicationClient_1.mapApplicationVersionResponse),
    applications: d.applications && (0, mapObjectValues_1.default)(d.applications, ApplicationClient_1.mapApplicationV2Response),
    themes: d.themes && (0, mapObjectValues_1.default)(d.themes, ThemeClient_1.mapThemeV2Response),
    device: d.device && {
        id: d.device.id,
        name: d.device.name,
        timezone: d.device.timezone,
        r: {
            resource: (0, ResourceClient_1.mapResourceV2Response)(d.device.r.resource),
        },
    },
    isMultitimezoneEnabled: d.is_multitimezone_enabled,
});
exports.mapDeviceContent = mapDeviceContent;
const mapRecentErrors = (re) => ({
    timestamp: re.timestamp,
    deviceId: re.device_id,
    event: re.event,
    errorMessage: re.error_message,
    presentationId: re.presentation_id,
    presentationName: re.presentation_name,
});
exports.mapRecentErrors = mapRecentErrors;
const mapDeviceRegionResponse = (r) => ({
    id: r.id ? r.id : '',
    name: r.name,
    width: r.width,
    height: r.height,
    depth: r.depth,
    positionX: r.position_x,
    positionY: r.position_y,
    positionZ: r.position_z,
    surgeCount: r.surge_count,
    surgeFrames: r.surge_frames,
    volumeAverageFrame: r.volume_average_frame,
});
exports.mapDeviceRegionResponse = mapDeviceRegionResponse;
const mapDevicePerchSettingsReponse = (pd) => ({
    id: pd.id,
    deviceServiceId: pd.device_service_id,
    cameraPositionX: pd.camera_position_x,
    cameraPositionY: pd.camera_position_y,
    cameraPositionZ: pd.camera_position_z,
    cameraRotationX: pd.camera_rotation_x,
    cameraRotationY: pd.camera_rotation_y,
    cameraRotationZ: pd.camera_rotation_z,
    minPoints: pd.min_points,
    frameThreshold: pd.frame_threshold,
    regions: pd.regions.map((region) => (0, exports.mapDeviceRegionResponse)(region)),
    createdAt: pd.created_at,
    updatedAt: pd.updated_at,
    settings: pd.settings,
});
exports.mapDevicePerchSettingsReponse = mapDevicePerchSettingsReponse;
const mapDeviceV2PerchSettingsReponse = (pd) => ({
    id: pd.id,
    deviceServiceId: pd.device_service_id,
    settings: pd.settings,
    createdAt: pd.created_at,
    updatedAt: pd.updated_at,
});
exports.mapDeviceV2PerchSettingsReponse = mapDeviceV2PerchSettingsReponse;
const mapBatchActionStatusResponse = (response) => ({
    action: response.action,
    status: response.status,
    createdAt: response.created_at,
    completedAt: response.completed_at,
    message: response.message,
});
exports.mapBatchActionStatusResponse = mapBatchActionStatusResponse;
const mapBatchDeviceStatusResponse = (response) => ({
    deviceId: response.device_id,
    profileId: response.profile_id,
    actionStatus: response.action_status.map((actionStatus) => (0, exports.mapBatchActionStatusResponse)(actionStatus)),
});
exports.mapBatchDeviceStatusResponse = mapBatchDeviceStatusResponse;
const mapDeviceChargeResponse = (response) => ({
    id: response.id,
    deviceId: response.device_id,
    orderId: response.order_id,
    externalId: response.external_id,
    status: response.status,
    items: response.items,
    error: response.error,
    updatedAt: response.updated_at,
    createdAt: response.created_at,
    subTotal: response.sub_total,
    tip: response.tip,
    tax: response.tax,
    total: response.total,
    cardType: response.card_type,
    cardBrand: response.card_brand,
    cardLast4: response.card_last4,
    transactionType: response.transaction_type,
    entryMode: response.entry_mode,
    authCode: response.auth_code,
    transactionNumber: response.transaction_number,
    pinVerified: response.pin_verified,
    verificationResult: response.verification_result,
    statusIndicator: response.status_indicator,
    applicationIdentifier: response.application_identifier,
    applicationName: response.application_name,
    applicationCryptogram: response.application_cryptogram,
    applicationData: response.application_data,
    applicationResponseCode: response.application_response_code,
    cardVerificationMethod: response.card_verification_method,
});
exports.mapDeviceChargeResponse = mapDeviceChargeResponse;
const mapV5DevicePlaylistResponse = (p) => {
    var _a, _b, _c, _d, _e;
    return ({
        id: p.id,
        name: p.name,
        lastActivityAt: p.last_activity_at,
        updatedAt: p.updated_at,
        ownedBy: {
            id: (_a = p.owned_by) === null || _a === void 0 ? void 0 : _a.id,
            email: (_b = p.owned_by) === null || _b === void 0 ? void 0 : _b.email,
            name: (_c = p.owned_by) === null || _c === void 0 ? void 0 : _c.name,
            thumbnailUrl: (_d = p.owned_by) === null || _d === void 0 ? void 0 : _d.thumbnail_url,
            domainRole: (_e = p.owned_by) === null || _e === void 0 ? void 0 : _e.domain_role,
        },
    });
};
exports.mapV5DevicePlaylistResponse = mapV5DevicePlaylistResponse;
const mapV5DeviceResponse = (d) => {
    var _a, _b, _c, _d, _e, _f;
    return ({
        id: d.id,
        macAddress: d.mac_address,
        playlistId: d.playlist_id,
        name: d.name,
        description: d.description,
        model: d.model,
        resourceId: d.resource_id,
        lastActivityAt: d.last_activity_at,
        updatedAt: d.updated_at,
        publishedAt: d.published_at,
        screenDimensions: d.screen_dimensions,
        screenOrientation: d.screen_orientation,
        registrationStatus: d.registration_status,
        registeredAt: d.registered_at,
        resinUuid: d.resin_uuid,
        isDisabled: d.is_disabled,
        isAudioOnly: d.is_audio_only,
        timezone: d.timezone,
        dailyRestartTime: d.daily_restart_time,
        dailyRebootTime: d.daily_reboot_time,
        activeHoursStart: d.active_hours_start,
        activeHoursEnd: d.active_hours_end,
        lastHeartbeatAt: d.last_heartbeat_at,
        isLite: d.is_lite,
        publishAck: d.publish_ack,
        publishPlaybackSuccess: d.publish_playback_success,
        publishPlaybackError: d.publish_playback_error,
        toastRestaurantGuid: d.toast_restaurant_guid,
        isUhd: d.is_uhd,
        services: d.services,
        deviceFeatures: d.device_features,
        ownedBy: {
            id: (_a = d.owned_by) === null || _a === void 0 ? void 0 : _a.id,
            email: (_b = d.owned_by) === null || _b === void 0 ? void 0 : _b.email,
            name: (_c = d.owned_by) === null || _c === void 0 ? void 0 : _c.name,
            thumbnailUrl: (_d = d.owned_by) === null || _d === void 0 ? void 0 : _d.thumbnail_url,
            domainRole: (_e = d.owned_by) === null || _e === void 0 ? void 0 : _e.domain_role,
        },
        metrics: d.metrics ? mapMetricsResponse(d.metrics) : null,
        playlist: d.playlist ? (0, exports.mapV5DevicePlaylistResponse)(d.playlist) : null,
        location: d.location ? (0, LocationClient_1.mapLocationResponse)(d.location) : null,
        tags: d.tags,
        acl: (_f = d.acl) === null || _f === void 0 ? void 0 : _f.map((acl) => (0, LocationClient_1.mapLocationACLResponse)(acl)),
        deviceType: d.device_type,
        screenManufacturer: d.screen_manufacturer,
        screenModel: d.screen_model,
        screenOsVersion: d.screen_os_version,
        screenSerialNumber: d.screen_serial_number,
        terminal: d.terminal
            ? {
                id: d.terminal.id,
                externalId: d.terminal.external_id,
                createdAt: d.terminal.created_at,
                updatedAt: d.terminal.updated_at,
                connection: null,
            }
            : null,
        activeMonitors: d.active_monitors,
        aiCameraStatus: d.ai_camera_status,
        rxCameraStatus: d.rx_camera_status,
        rxIrFrameStatus: d.rx_ir_frame_status,
    });
};
exports.mapV5DeviceResponse = mapV5DeviceResponse;
const mapV3DeviceToV5Device = (v3, v5) => {
    var _a, _b;
    return (Object.assign(Object.assign({}, v5), { activeHoursEnd: v3.active_hours_end, activeHoursStart: v3.active_hours_start, dailyRebootTime: v3.daily_reboot_time, dailyRestartTime: v3.daily_restart_time, description: v3.description, isAudioOnly: v3.is_audio_only, isUhd: v3.is_uhd, name: v3.name, playlistId: v3.playlist_id, tags: ((_b = (_a = v3.resource) === null || _a === void 0 ? void 0 : _a.r) === null || _b === void 0 ? void 0 : _b.tags) || [], screenDimensions: v3.screen_dimensions, screenOrientation: v3.screen_orientation, timezone: v3.timezone, lastHeartbeatAt: v3.last_heartbeat_at, toastRestaurantGuid: v3.toast_restaurant_guid }));
};
exports.mapV3DeviceToV5Device = mapV3DeviceToV5Device;
const mapV5DeviceToV3Device = (v5) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    return ({
        id: v5.id,
        name: v5.name,
        description: v5.description,
        model: v5.model,
        device_features: v5.device_features,
        metrics: v5.metrics,
        published_at: v5.published_at,
        registered_at: v5.registered_at,
        screen_dimensions: v5.screen_dimensions,
        screen_orientation: v5.screen_orientation,
        application_thumbnail_url: '',
        resin_uuid: v5.resin_uuid,
        playlist_id: v5.playlist_id,
        playlist: {
            id: ((_a = v5.playlist) === null || _a === void 0 ? void 0 : _a.id) || '',
            resource: {
                id: '',
                profile: {
                    id: ((_c = (_b = v5.playlist) === null || _b === void 0 ? void 0 : _b.owned_by) === null || _c === void 0 ? void 0 : _c.id) || '',
                    email: ((_e = (_d = v5.playlist) === null || _d === void 0 ? void 0 : _d.owned_by) === null || _e === void 0 ? void 0 : _e.email) || '',
                    name: ((_g = (_f = v5.playlist) === null || _f === void 0 ? void 0 : _f.owned_by) === null || _g === void 0 ? void 0 : _g.name) || '',
                    thumbnail_url: ((_j = (_h = v5.playlist) === null || _h === void 0 ? void 0 : _h.owned_by) === null || _j === void 0 ? void 0 : _j.thumbnail_url) || '',
                    domain_id: ((_l = (_k = v5.playlist) === null || _k === void 0 ? void 0 : _k.owned_by) === null || _l === void 0 ? void 0 : _l.domain_id) || '',
                    domain_role: ((_o = (_m = v5.playlist) === null || _m === void 0 ? void 0 : _m.owned_by) === null || _o === void 0 ? void 0 : _o.domain_role) || 'restricted',
                },
                domain: null,
                created_at: '',
                updated_at: ((_p = v5.playlist) === null || _p === void 0 ? void 0 : _p.updated_at) || '',
                last_activity_at: ((_q = v5.playlist) === null || _q === void 0 ? void 0 : _q.last_activity_at) || '',
                deleted_at: '',
                parent_folder_id: '',
                r: {
                    resource_acls: null,
                    tags: null,
                },
            },
            name: ((_r = v5.playlist) === null || _r === void 0 ? void 0 : _r.name) || '',
        },
        is_uhd: v5.is_uhd,
        is_audio_only: v5.is_audio_only,
        resource: {
            id: v5.resource_id,
            profile: {
                id: ((_s = v5.owned_by) === null || _s === void 0 ? void 0 : _s.id) || '',
                email: ((_t = v5.owned_by) === null || _t === void 0 ? void 0 : _t.email) || '',
                name: ((_u = v5.owned_by) === null || _u === void 0 ? void 0 : _u.name) || '',
                thumbnail_url: ((_v = v5.owned_by) === null || _v === void 0 ? void 0 : _v.thumbnail_url) || '',
                domain_id: ((_w = v5.owned_by) === null || _w === void 0 ? void 0 : _w.domain_id) || '',
                domain_role: ((_x = v5.owned_by) === null || _x === void 0 ? void 0 : _x.domain_role) || 'restricted',
            },
            domain: null,
            created_at: '',
            updated_at: v5.updated_at || '',
            last_activity_at: v5.last_activity_at,
            deleted_at: '',
            parent_folder_id: '',
            r: {
                resource_acls: (_y = v5.acl) === null || _y === void 0 ? void 0 : _y.map((acl) => {
                    var _a, _b, _c;
                    return ({
                        id: acl.id,
                        resource_id: v5.resource_id,
                        profile_id: ((_a = v5.owned_by) === null || _a === void 0 ? void 0 : _a.id) || '',
                        grant_profile_id: (_b = acl.grant_profile) === null || _b === void 0 ? void 0 : _b.id,
                        grant_domain_id: acl.grant_domain_id,
                        grant_scope: acl.grant_scope,
                        read_grant: acl.read_grant,
                        update_grant: acl.update_grant,
                        delete_grant: acl.delete_grant,
                        custom_access_grants: acl.custom_access_grants || [],
                        share_grant: acl.share_grant,
                        full_grant: acl.full_grant,
                        created_at: '',
                        updated_at: '',
                        r: {
                            grant_profile: Object.assign(Object.assign({}, acl.grant_profile), { thumbnail_url: ((_c = acl.grant_profile) === null || _c === void 0 ? void 0 : _c.thumbnail_url) || '', domain_id: '' }),
                            profile: Object.assign(Object.assign({}, v5.owned_by), { domain_id: '' }),
                        },
                    });
                }),
                tags: (_z = v5.tags) === null || _z === void 0 ? void 0 : _z.map((v5tag) => (Object.assign(Object.assign({}, v5tag), { resource_id: '', created_at: '', profile_id: '' }))),
            },
        },
        last_heartbeat_at: v5.last_heartbeat_at,
        last_online_at: '',
        is_lite: v5.is_lite,
        publish_ack: v5.publish_ack,
        publish_playback_success: v5.publish_playback_success,
        publish_playback_error: v5.publish_playback_error,
        timezone: v5.timezone,
        active_hours_start: v5.active_hours_start,
        active_hours_end: v5.active_hours_end,
        daily_reboot_time: v5.daily_reboot_time,
        daily_restart_time: v5.daily_restart_time,
        toast_restaurant_guid: v5.toast_restaurant_guid,
        services: v5.services,
        device_type: v5.device_type,
        screen_manufacturer: v5.screen_manufacturer,
        screen_model: v5.screen_model,
        screen_os_version: v5.screen_os_version,
        screen_serial_number: v5.screen_serial_number,
        location: v5.location,
        terminal: v5.terminal,
        active_monitors: v5.active_monitors,
        ai_camera_status: v5.ai_camera_status,
        rx_camera_status: v5.rx_camera_status,
        rx_ir_frame_status: v5.rx_ir_frame_status,
    });
};
exports.mapV5DeviceToV3Device = mapV5DeviceToV3Device;
const mapDeviceTerminalResponse = (d) => ({
    id: d.id,
    deviceId: d.device_id,
    externalId: d.external_id,
    createdAt: d.created_at,
    updatedAt: d.updated_at,
    connection: (0, ConnectionClient_1.mapConnectionResponse)(d.connection),
});
class DeviceClient {
    getDevice(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: `${urls_1.default.devices()}?filter=id eq ${id}`,
            });
            return (0, exports.mapDeviceResponse)(data[0]);
        });
    }
    enableDeviceService(id, service) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'PUT',
                url: urls_1.default.deviceService(id, service),
            });
            return data;
        });
    }
    disableDeviceService(id, service) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'DELETE',
                url: urls_1.default.deviceService(id, service),
            });
            return data;
        });
    }
    getDeviceAISettings(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.deviceAISettings(id),
            });
            return data;
        });
    }
    setDeviceAISettings(id, settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.deviceAISettings(id),
                body: { settings: settings },
            });
            return data;
        });
    }
    setDeviceAILicenseKey(id, license_key) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.deviceAILicenseKey(id),
                body: { license_key: license_key },
            });
            return data;
        });
    }
    startDeviceAIVideo(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.deviceAIVideo(id),
                body: { video_stream: true },
            });
            return data;
        });
    }
    stopDeviceAIVideo(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.deviceAIVideo(id),
                body: { video_stream: false },
            });
            return data;
        });
    }
    getDevicePerchviewSettings(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.devicePerchviewSettings(id),
            });
            return (0, exports.mapDevicePerchSettingsReponse)(data);
        });
    }
    getOwnPerchviewSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.deviceOwnPerchviewSettings(),
            });
            return (0, exports.mapDeviceV2PerchSettingsReponse)(data);
        });
    }
    setDevicePerchviewSettings(id, settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.devicePerchviewSettings(id),
                body: settings,
            });
            return (0, exports.mapDevicePerchSettingsReponse)(data);
        });
    }
    updateDevicePerchviewSettings(id, settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.devicePerchviewSettings(id),
                body: settings,
            });
            return (0, exports.mapDevicePerchSettingsReponse)(data);
        });
    }
    // Perchview Settings V2
    getDeviceV2PerchviewSettings(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.deviceV2PerchviewSettings(id),
            });
            return (0, exports.mapDeviceV2PerchSettingsReponse)(data);
        });
    }
    setDeviceV2PerchviewSettings(id, settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.deviceV2PerchviewSettings(id),
                body: settings,
            });
            return (0, exports.mapDeviceV2PerchSettingsReponse)(data);
        });
    }
    updateDeviceV2PerchviewSettings(id, settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.deviceV2PerchviewSettings(id),
                body: settings,
            });
            return (0, exports.mapDeviceV2PerchSettingsReponse)(data);
        });
    }
    batchDeviceSettings(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.deviceBatchSettings(),
                body: params,
            });
            return data;
        });
    }
    getBatchDeviceStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.deviceBatchStatus(),
            });
            return data.map(exports.mapBatchDeviceStatusResponse);
        });
    }
    getDevices(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const filterQs = filter ? `filter=id in ${filter.ids.join(',')}` : '';
            const data = yield this.requestProtected({
                method: 'GET',
                url: `${urls_1.default.devices()}?${filterQs}`,
            });
            return data.map(exports.mapDeviceResponse);
        });
    }
    getV4ReportingDevices(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.v4ReportingDevices(query),
            });
            return res;
        });
    }
    getV5Device() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.v5Device(),
            });
            return {
                name: res.name,
                registrationStatus: res.registration_status,
                confirmationToken: res.confirmation_token,
                publishedAt: res.published_at,
            };
        });
    }
    getV5Devices(query) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.v5Devices(query),
            });
            return {
                total: res.total,
                data: (_a = res.data) === null || _a === void 0 ? void 0 : _a.map((device) => (0, exports.mapV5DeviceResponse)(device)),
            };
        });
    }
    updateDevice(id, params) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.device(id),
                body: {
                    name: params.name,
                    screen_dimensions: params.screenDimensions,
                    screen_orientation: params.screenOrientation,
                    description: params.description,
                    playlist_id: params.playlistId,
                    is_uhd: params.isUhd,
                    is_audio_only: params.isAudioOnly,
                    timezone: params.timezone,
                    active_hours_start: params.activeHoursStart,
                    active_hours_end: params.activeHoursEnd,
                    daily_reboot_time: params.dailyRebootTime,
                    daily_restart_time: params.dailyRestartTime,
                    resource: params.resource && {
                        r: params.resource.r && {
                            tags: (_a = params.resource.r.tags) === null || _a === void 0 ? void 0 : _a.map((t) => ({
                                type: t.type,
                                key: t.key,
                                label: t.label,
                                value: t.value,
                            })),
                        },
                    },
                    toast_restaurant_guid: params.toastRestaurantGuid,
                },
            });
            return (0, exports.mapDeviceResponse)(data);
        });
    }
    // Currently endpoint is returning type Device not V5Device
    // So we are simulating the response to be V5Device
    updateV5Device(id, params) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.device(id),
                body: {
                    name: params.name,
                    screen_dimensions: params.screenDimensions,
                    screen_orientation: params.screenOrientation,
                    description: params.description,
                    playlist_id: params.playlistId,
                    is_uhd: params.isUhd,
                    is_audio_only: params.isAudioOnly,
                    timezone: params.timezone,
                    active_hours_start: params.activeHoursStart,
                    active_hours_end: params.activeHoursEnd,
                    daily_reboot_time: params.dailyRebootTime,
                    daily_restart_time: params.dailyRestartTime,
                    resource: params.tags && {
                        r: {
                            tags: (_a = params.tags) === null || _a === void 0 ? void 0 : _a.map((t) => ({
                                type: t.type,
                                key: t.key,
                                label: t.label,
                                value: t.value,
                            })),
                        },
                    },
                    toast_restaurant_guid: params.toastRestaurantGuid,
                },
            });
            return (0, exports.mapV3DeviceToV5Device)(data, params);
        });
    }
    restartDevice(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.deviceRestart(id),
            });
        });
    }
    rebootDevice(id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.deviceReboot(id),
            });
        });
    }
    publishDevice(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.devicePublish(id),
            });
            return (0, exports.mapDeviceResponse)(data);
        });
    }
    registerDevice({ activationCode, name, timezone, locationId }) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, exports.mapDeviceResponse)(yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.devicesRegister(),
                body: {
                    confirmation_token: activationCode.toLowerCase(),
                    name: name ? name.trim() : activationCode,
                    timezone,
                    location_id: locationId,
                },
            }));
        });
    }
    getSYBSoundZone(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.deviceSYBSoundZone(id),
            });
            // We need the id to be the device id to lookup the sound zone and
            // we don't currently care about the actual sound zone id because
            // auth to SYB is uses the device id.
            return data ? { id, name: data.name } : { id, name: '' };
        });
    }
    generateSYBPairingCode(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.deviceSYBGeneratePairingCode(id),
            });
            // We need the id to be the device id to lookup the pairing code.
            return {
                id,
                pairingCode: data.pairing_code,
            };
        });
    }
    moveDeviceToFolder(deviceId, folderId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.deviceMoveToFolder(deviceId),
                body: {
                    folder_id: folderId,
                },
            });
        });
    }
    getAffectedDevices(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.devicesAffectedDevices(),
                body: {
                    presentation_ids: body.presentationIds || [],
                    playlist_ids: body.playlistIds || [],
                    folder_ids: body.folderIds || [],
                },
            });
            return data.map((d) => ({
                id: d.id,
                name: d.name,
            }));
        });
    }
    deviceHeartbeat(body = {}) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.deviceHeartbeat(),
                body: {
                    connection_type: body.connection_type,
                    ssid: body.ssid,
                    rssi: body.rssi,
                },
            });
            return {
                name: data.name,
                registrationStatus: data.registration_status,
                confirmationToken: data.confirmation_token,
                isDisabled: data.is_disabled,
                screenOrientation: data.screen_orientation,
                publishedAt: data.published_at,
                publishAck: (_a = data.publish_ack) !== null && _a !== void 0 ? _a : false,
                publishPlaybackSuccess: (_b = data.publish_playback_success) !== null && _b !== void 0 ? _b : false,
                publishPlaybackError: (_c = data.publish_playback_error) !== null && _c !== void 0 ? _c : false,
                polyServiceLevel: data.poly_service_level,
            };
        });
    }
    getDevicePublishedContent() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.devicePublishedContent(),
            });
            return (0, exports.mapDeviceContent)(data);
        });
    }
    getDeviceAdContent() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.deviceAdContent(),
            });
            return (0, exports.mapDeviceContent)(data);
        });
    }
    devicePubnubAuth(sessionId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.devicePubnubAuth(),
                body: {
                    session_id: sessionId,
                },
            });
            return {
                authKey: data.auth_key,
                channelId: data.channel_id,
                expiresAt: data.expires_at,
            };
        });
    }
    unregisterDevice(deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.deviceUnregister(deviceId),
            });
        });
    }
    getRecentDeviceErrors() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.devicesRecentErrors(),
            });
            return data.map(exports.mapRecentErrors);
        });
    }
    enableMultiTimezone(isDomainUser = true) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.enableMultiTimeZone(isDomainUser),
            });
        });
    }
    createDeviceCharge(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'POST',
                url: urls_1.default.deviceCharges(),
                body: {
                    order_id: params.orderId,
                    sub_total: params.subTotal,
                    tip: params.tip,
                    tax: params.tax,
                    total: params.total,
                    items: params.items,
                },
            });
            return (0, exports.mapDeviceChargeResponse)(data);
        });
    }
    updateDeviceCharge(chargeId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'PATCH',
                url: urls_1.default.deviceCharge(chargeId),
                body: {
                    external_id: params.externalId,
                    status: params.status,
                    error: params.error,
                    card_type: params.cardType,
                    card_brand: params.cardBrand,
                    transaction_type: params.transactionType,
                    pin_verified: params.pinVerified,
                    entry_mode: params.entryMode,
                    card_last4: params.cardLast4,
                    auth_code: params.authCode,
                    transaction_number: params.transactionNumber,
                    verification_result: params.verificationResult,
                    status_indicator: params.statusIndicator,
                    application_identifier: params.applicationIdentifier,
                    application_name: params.applicationName,
                    application_cryptogram: params.applicationCryptogram,
                    application_data: params.applicationData,
                    application_response_code: params.applicationResponseCode,
                    card_verification_method: params.cardVerificationMethod,
                },
            });
            return (0, exports.mapDeviceChargeResponse)(data);
        });
    }
    getDeviceTerminalStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.deviceTerminalStatus(),
            });
            return data;
        });
    }
    getDeviceTerminal(deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.deviceTerminal(deviceId),
            });
            return mapDeviceTerminalResponse(data);
        });
    }
    deleteDeviceTerminal(deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'DELETE',
                url: urls_1.default.deviceTerminal(deviceId),
            });
            return data;
        });
    }
}
exports.default = DeviceClient;
